import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const CrossIcon: FC<IconProps> = ({ width = 21, height = 15, ...rest }) => (
  <Icon type="Cross" width={width} height={height} alt="CrossIcon" {...rest} />
)
